import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";


export default function PrivateRoute({ children }) {
  const token = sessionStorage.getItem("token");
  let isLoggedIn = false;

  if (token) {
    try {
      const decoded = jwtDecode(token);       // decode JWT
      const now = Date.now() / 1000;           // current time in seconds
      isLoggedIn = decoded.exp > now;          // true if token not expired
    } catch (err) {
      console.error("Invalid token", err);
      isLoggedIn = false;
    }
  }

  return isLoggedIn ? children : <Navigate to="/" replace />;
}
